export const LICENCE_MANAGEMENT_GET_CUSTOMER_LICENCES = 'LICENCE_MANAGEMENT_GET_CUSTOMER_LICENCES'
export const LICENCE_MANAGEMENT_ADD_CUSTOMER_LICENCE = 'LICENCE_MANAGEMENT_ADD_CUSTOMER_LICENCE'
export const LICENCE_MANAGEMENT_UPDATE_LICENCE_REVOKED = 'LICENCE_MANAGEMENT_UPDATE_LICENCE_REVOKED'
